import { useRoleListForm } from "../customHooks";
import React from "react";
import FormError from "./FormError";

function RoleSelect({
  formik,
  withDefault,
}: {
  formik: any;
  withDefault?: boolean;
}) {
  const { data, error, isLoading } = useRoleListForm();

  const { setFieldValue } = formik;
  React.useEffect(() => {
    if (data && withDefault && !formik.values?.role) {
      setFieldValue("role", data[0]?.id || data[0]?._id);
    }
  }, [data]);

  if (isLoading) {
    return <div>در حال بارگذاری...</div>;
  }

  if (error) {
    return <div>خطا در بارگذاری نقش‌ها</div>;
  }

  if (data === undefined || data?.length === 0 || data === null) {
    return <div>هیچ نقشی یافت نشد</div>;
  }

  return (
    <div style={{ minWidth: 200 }}>
      <select
        className="form-select form-select-solid"
        name={"role"}
        value={formik.values?.role?.id || formik.values?.role?._id || formik.values?.role}
        onChange={(e) => {
          setFieldValue("role", e.target.value);
        }}
      >
        {!formik.values.role && (
          <option value="" className={"py-3 "}>لطفا نقش را انتخاب کنید</option>
        )}
        {/*@ts-ignore*/}
        {data?.map((c) => (
          <option key={c.id || c._id} value={c.id || c._id}>
            {c.name || c.faName}
          </option>
        ))}
      </select>
      <FormError formik={formik} fieldName={"role"} />
    </div>
  );
}

export default RoleSelect;
